import { useMemo } from 'react';

import { RadioGroup } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import { MedicalDeviceOrderFormRegister } from '../medicalDeviceOrder.types';

type DeviceTypeFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister;
};

export const DeviceTypeField = (props: DeviceTypeFieldProps): JSX.Element => {
   const items = useMemo(() => [{ id: 'OTHER', label: medicalDevicesTranslationKeys.fields.otherDeviceType }], []);
   return (
      <RadioGroup
         label={medicalDevicesTranslationKeys.fields.deviceType}
         testId={'deviceType'}
         items={items}
         controller={props.register('deviceType', { required: true })}
         horizontal
         disabled
      />
   );
};
